module.exports = __webpack_public_path__ + "media/sax.137f6ef6.mp3";